import { createContext } from "react";

export const AcicConsentLayoutContext = createContext<{
  label?: string;
  subLabel?: string;
}>({});
